import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website'
}) => {
  const siteName = 'AASPS - Associação de Apoio e Segurança Psico-Social';
  const defaultDescription = 'A AASPS promove a saúde mental na comunidade através de serviços de reabilitação psicossocial, apoio psicológico e projetos de inclusão social em Barcelos.';
  const defaultImage = 'https://customer-assets.emergentagent.com/job_a31c033b-2ebd-4113-a585-0096573fcedb/artifacts/v4nxsceg_act.jpg';
  const siteUrl = 'https://aasps.pt';

  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const metaUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={metaUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="pt_PT" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={metaUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="AASPS" />
      <meta name="geo.region" content="PT-03" />
      <meta name="geo.placename" content="Barcelos" />
      <html lang="pt-PT" />
    </Helmet>
  );
};

export default SEO;
